import { render, staticRenderFns } from "./SubmitBtn.vue?vue&type=template&id=e4a4e606&scoped=true&"
import script from "./SubmitBtn.vue?vue&type=script&lang=js&"
export * from "./SubmitBtn.vue?vue&type=script&lang=js&"
import style0 from "./SubmitBtn.vue?vue&type=style&index=0&id=e4a4e606&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a4e606",
  null
  
)

export default component.exports